import { z } from 'zod';

// Nested Schemas
export const FishCatchSchema = z.object({
  species: z.string(),
  caught: z.boolean(),
  sizeCm: z.number().optional(),
  date: z.string(),
  highlight: z.boolean().optional(),
  photoUrl: z.string().optional(),
});

export const TripParticipantSchema = z.object({
  clientId: z.string(),
  roleInGroup: z.enum(['leader', 'member']),
  catches: z.array(FishCatchSchema),
});

export const BudgetConfigSchema = z.object({
  peopleCount: z.number(),
  packageDays: z.number().optional(),
  items: z.array(z.any()), // array of any as per interface
  servicesIncluded: z.array(z.string()).optional(),
});

export const TripSchema = z.object({
  id: z.string(),
  fishingCode: z.string(),
  
  // Date Fields (Strings in FishingTrip)
  // We accept Date objects (from DatePicker) or Strings, and normalize to ISO String
  arrivalDate: z.union([z.string(), z.date()]).transform(val => new Date(val).toISOString()), 
  departureDate: z.union([z.string(), z.date()]).transform(val => new Date(val).toISOString()),
  
  reservationStatus: z.string(),
  
  // Financials
  financials: z.object({
    totalValue: z.number(),
    depositValue: z.number(),
    isPaid: z.boolean(),
  }),
  
  // Optional configs
  budgetConfig: BudgetConfigSchema.optional(),
  contractDetails: z.string().optional(),
  
  // Clients & Guides
  leaderClientId: z.string(),
  mainGuideId: z.string().optional(),
  assistantGuidesIds: z.array(z.string()).optional(),
  
  // Details
  stayType: z.string().optional(),
  fishingSuccess: z.boolean().optional(),
  
  // Participants
  participants: z.array(TripParticipantSchema),
  
  // Status
  status: z.string().optional(),
  contractStatus: z.enum(['generated', 'signed', 'pending']).optional(),
  
  // Extra fields that might exist in Firestore but not in FishingTrip interface
  // We allow them via passthrough, but don't enforce them.
}).passthrough();

export type FishingTrip = z.infer<typeof TripSchema>;
